module.exports = __webpack_public_path__ + "img/view_doc_purple.076855c1.svg";